import { IMagicUserLogin } from '@app-types/api/user.types';
import { loginMagic } from '@services/user/user.actions';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {Paper, Typography, withStyles, WithStyles} from "@material-ui/core";
import Button from "@components/common/button/Button";
import TranslateNew from "@translate/TranslateNew";
import {MagicContainerStyle as styles} from './magic.style';


const tn:TranslateNew = TranslateNew.getInstance();



interface IProps extends RouteComponentProps, WithStyles<typeof styles> {
  loginMagic: (values: IMagicUserLogin) => void;
  token?: string;
}

interface IRouteParams {
  token?: string;
}

interface IState {
  start: number;
}

class PMagicContainer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      start: Date.now()
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (this.props.token && this.props.token !== prevProps.token) {
      // Logged in. Replace, so Back does not return to the used link.
      this.props.history.replace("/app/settings/:userId");
    }
  }

  public componentDidMount() {
    // console.log("MagicContainer...", JSON.stringify(this.props.match.params));
    const { token } = this.props.match.params as IRouteParams;
    this.setState({ start: Date.now() });

    if (token) {
      this.props.loginMagic({
        token,
        history: this.props.history
      });
    }
  }

  public render() {
    const { classes, history } = this.props;

    return (
      <Paper className={classes.root}>
        <Typography align="center" component="h1" variant="h6">
          {tn.lang.verifying}
        </Typography>


        <Button 
          onClick={() => history.push("/login")} 
          className={classes.button} 
          variant="contained" 
          color="primary"
          fullWidth={true}
        >
          {tn.lang.back}
        </Button>
      </Paper>
    );
  }
}

const mapDispatchToProps = {
  loginMagic
};

function mapStateToProps(state: any) {
  if (!state.user || !state.user.session || !state.user.session.data || !state.user.session.data.authorization) {
    return {
      token: undefined
    };
  }
  return {
    token: state.user.session.data.authorization
  };
}

const MagicContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PMagicContainer)));

export default MagicContainer;



// WEBPACK FOOTER //
// ./src/containers/magic/magic.container.tsx